class TransToast {
  private toastRef: { current: any } | null = null;

  setToast(toastRef: { current: any }) {
    this.toastRef = toastRef;
  }

  ShowSuccess(message: string, className?: string) {
    this.toastRef?.current.show({
      severity: "success",
      summary: "Success",
      detail: message,
      life: 5000,
      className,
    });
  }

  ShowFailure(message?: string, className?: string) {
    this.toastRef?.current.show({
      severity: "error",
      summary: "Error",
      detail: message ?? "Something went wrong Please try again !",
      life: 5000,
      className,
    });
  }

  // Validation / non-blocking warning toast (e.g. admin form checks).
  ShowWarning(message: string, className?: string) {
    this.toastRef?.current.show({
      severity: "warn",
      summary: "Warning",
      detail: message,
      life: 5000,
      className,
    });
  }

  clear() {
    this.toastRef?.current?.clear();
  }
}

const TransactionToast = new TransToast();
export default TransactionToast;
